<script setup lang="ts" generic="T">
import { useModal } from '@/stores/useModalStore';

const props = defineProps<{
	props?: T;
}>();

const slots = defineSlots<{
	default(props: T): any;
}>();

const { hide, show } = useModal({
	component: slots.default,
	props: props.props
});

defineExpose({ hide, show });
</script>
